/* Fill resource sliders from the complete blog index and curated topic labels. */
(() => {
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  function card(article) {
    const slide = make('article', 'embla__slide');
    slide.setAttribute('role', 'group');
    slide.setAttribute('aria-roledescription', 'slide');
    slide.dataset.articleId = article.id;
    const inner = make('div', 'slide-inner');
    if (article.image) {
      const image = make('div', 'article-image');
      const frame = make('div', 'article-image-inner');
      const img = document.createElement('img');
      img.src = article.image;
      img.alt = article.imageAlt || article.title;
      img.loading = 'lazy';
      frame.append(img); image.append(frame); inner.append(image);
    }
    const text = make('div', 'article-text');
    const title = make('h5', 'article-title');
    const link = make('a', '', article.title);
    link.href = article.url; title.append(link);
    const template = document.createElement('template');
    template.innerHTML = article.excerpt || '';
    const words = template.content.textContent.trim().split(/\s+/);
    const excerpt = make('p', '', words.slice(0, 15).join(' ') + (words.length > 15 ? '…' : ''));
    const more = make('a', 'read-more', 'Read more'); more.href = article.url;
    text.append(title, excerpt, more);
    inner.append(text, make('span', 'component-corners-left'), make('span', 'component-corners-right'));
    slide.append(inner); return slide;
  }
  async function load(section) {
    const controller = new AbortController();
    section.motorResourcesController = controller;
    section.dataset.resourcesState = 'loading';
    const config = JSON.parse(section.querySelector('[data-motor-topic-config]').textContent).articles;
    const fold = value => String(value).normalize('NFKD').toLowerCase().replace(/[\s_-]+/g,' ').trim();
    const topic = fold(section.dataset.resourceTopic || 'Motor');
    async function read(number) {
      const url = new URL(section.dataset.blogUrl, location.href);
      url.searchParams.set('view', 'directory-data'); url.searchParams.set('page', number);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.any([controller.signal, AbortSignal.timeout(20000)])});
          if (!response.ok) throw new Error('Article index unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = JSON.parse(doc.querySelector('[data-blog-directory-index]').textContent);
          if (data.blog !== 'articles' || data.page !== number || !Array.isArray(data.articles) || data.pages > 500) throw new Error('Invalid article index');
          return data;
        } catch (error) {
          if (controller.signal.aborted || attempt === 2) throw error;
          await new Promise(resolve => setTimeout(resolve, 500 * (attempt + 1)));
        }
      }
    }
    try {
      const first = await read(1), articles = new Map(first.articles.map(a => [String(a.id), a]));
      // The complete index includes older articles beyond the first 50 posts.
      for (let number = 2; number <= first.pages; number++) {
        const page = await read(number);
        page.articles.forEach(a => articles.set(String(a.id), a));
      }
      const matches = [...articles.values()].filter(a =>
        a.url?.startsWith(section.dataset.blogUrl + '/') &&
        [...(a.tags || []), ...(config.assignments[String(a.id)] || [])].some(tag => fold(tag).includes(topic))
      ).sort((a, b) => Date.parse(b.date) - Date.parse(a.date));
      if (!matches.length || !section.isConnected) return;
      const carousel = section.querySelector('[data-embla]');
      carousel.querySelector('.embla__container').replaceChildren(...matches.map(card));
      carousel.emblaApi?.reInit();
      section.dataset.resourceCount = matches.length;
      section.dataset.resourcesState = 'ready';
    } catch {
      // Keep the curated server-rendered cards if the index cannot be loaded.
      section.dataset.resourcesState = 'fallback';
    }
  }
  function init(scope) {
    scope.querySelectorAll('[data-motor-resources]').forEach(section => {
      if (section.motorResourcesObserver) return;
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(section); }
      }, {rootMargin: '1000px'});
      section.motorResourcesObserver = observer;
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-motor-resources]').forEach(section => {
    section.motorResourcesObserver?.disconnect(); section.motorResourcesController?.abort();
  }));
})();
